class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}${searchParams ? '&' + searchParams : ''}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);

        // Dispatch custom event for dynamic size filters
        document.dispatchEvent(new CustomEvent('facet:rendered', { detail: { html, event } }));
      });

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".grid-content-item")
      .forEach((gridContentItem) => {
        gridContentItem.classList.add("hide-item");
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);

    // Dispatch custom event for dynamic size filters
    document.dispatchEvent(new CustomEvent('facet:rendered', { detail: { html, event } }));
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById("ProductGridContainer");
    
    if (window.currentAjaxinateInstance) {
      window.currentAjaxinateInstance.destroy();
      window.currentAjaxinateInstance = null;
    }

    const ajaxinateLoop = container.querySelector("#AjaxinateLoop");
    if (ajaxinateLoop) {
      const chunks = ajaxinateLoop.querySelectorAll('.ajaxinate-chunk');
      chunks.forEach(chunk => chunk.remove());
      const placeholders = ajaxinateLoop.querySelectorAll('.ajaxinate-placeholder');
      placeholders.forEach(placeholder => placeholder.remove());
      const skeletons = ajaxinateLoop.querySelectorAll('.skeleton');
      skeletons.forEach(skeleton => skeleton.remove());
    }

    container.innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    window.scrollTo({ top: 0, behavior: 'smooth' });

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });

    document
      .querySelectorAll(".grid-content-item")
      .forEach((gridContentItem) => {
        gridContentItem.classList.add("hidden");
      });

    const newAjaxinateLoop = document.querySelector("#AjaxinateLoop");
    const newAjaxinatePagination = document.querySelector("#AjaxinatePagination");
    
    if (newAjaxinateLoop && newAjaxinatePagination) {
      const ajaxinateInstance = new Ajaxinate({
        container: "#AjaxinateLoop",
        pagination: "#AjaxinatePagination",
        preload: true
      });
      
      window.currentAjaxinateInstance = ajaxinateInstance;
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    document.dispatchEvent(new CustomEvent('facet:updated', { detail: { event } }));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    let newSearchParams = new URLSearchParams(formData).toString();
    if (newSearchParams.includes("filter.v.option") && !newSearchParams.includes("filter.v.availability")) {
      newSearchParams = newSearchParams + "&filter.v.availability=1";
    }
    return newSearchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      let sortValue = null;
      const targetForm = event.target.closest("form");
      const sortSelectInForm = targetForm ? targetForm.querySelector('select[name="sort_by"]') : null;
      if (sortSelectInForm && sortSelectInForm.value) {
        sortValue = sortSelectInForm.value;
      } else {
        const allSortSelects = document.querySelectorAll('select[name="sort_by"]');
        if (allSortSelects.length > 0) {
          sortValue = allSortSelects[0].value;
        }
      }

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            if (form.id === "FacetSortForm" || form.id === "FacetSortDrawerForm") {
              if (sortValue) {
                forms.push(`sort_by=${encodeURIComponent(sortValue)}`);
              }
            } else {
              const params = this.createSearchParams(form);
              if (params) {
                forms.push(params);
              }
            }
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          const params = this.createSearchParams(form);
          if (params) {
            forms.push(params);
          }
        }
      });
      
      if (sortValue && !forms.some(p => p && p.includes('sort_by='))) {
        forms.unshift(`sort_by=${encodeURIComponent(sortValue)}`);
      }
      
      const combinedParams = forms.filter(p => p && p.trim()).join("&");
      this.onSubmitForm(combinedParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf("?") + 1
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class DynamicFilters {
  constructor() {
    this.filterContainers = document.querySelectorAll('filter-buttons[data-filter]');
    this.facetForm = document.querySelector('#FacetFiltersForm');
    this.mobileFacetForm = document.querySelector('#FacetFiltersFormMobile');
    this.init();
  }

  init() {
    if (this.filterContainers.length === 0) return;

    this.waitForFacets();
  }

  waitForFacets() {
    const checkFacets = () => {
      const allFilters = document.querySelectorAll('facet-filters-form .js-filter');

      if (allFilters.length > 0) {
        this.extractAndCreateFilters();
      } else {
        setTimeout(checkFacets, 100);
      }
    };

    checkFacets();
  }

  extractAndCreateFilters() {
    this.filterContainers.forEach(container => {
      const buttonsContainer = container.querySelector('.filter-buttons');
      if (!buttonsContainer) return;

      buttonsContainer.innerHTML = '';

      const filterType = container.dataset.filter;
      const filters = this.findFiltersByType(filterType);

      if (filters.length === 0) {
        container.classList.add('hidden');
        return;
      }

      filters.forEach(filter => {
        this.createFilterButtons(filter, buttonsContainer);
      });

      // Count total valid filter buttons
      const totalButtons = buttonsContainer.querySelectorAll('.filter-button').length;
      
      if (totalButtons > 1) {
        container.classList.remove('hidden');
      } else {
        container.classList.add('hidden');
      }
    });

    this.updateButtonStates();
  }

  findFiltersByType(filterType) {
    const filters = [];
    const processedIds = new Set();

    const allFilters = document.querySelectorAll('facet-filters-form .js-filter');

    // Map filter types to their actual parameter names
    const filterTypeMap = {
      'size': ['size', 'filter.v.option.size'],
      'type': ['product_type', 'filter.p.product_type', 'type'],
      'category': ['filter.p.m.custom.category', 'custom.category'],
      'color': ['color', 'filter.v.option.color'],
      'vendor': ['vendor', 'filter.p.vendor'],
      'tag': ['tag', 'filter.p.tag']
    };

    // Get the search terms for this filter type
    const searchTerms = filterTypeMap[filterType.toLowerCase()] || [filterType.toLowerCase()];

    allFilters.forEach((filter) => {
      const filterId = filter.id;

      if (processedIds.has(filterId)) {
        return;
      }

      // Check if the filter ID contains any of the search terms for this filter type
      const matches = searchTerms.some(term => 
        filterId && filterId.toLowerCase().includes(term.toLowerCase())
      );

      if (matches) {
        processedIds.add(filterId);

        const summary = filter.querySelector('.facets__summary-label, .mobile-facets__summary span');
        const label = summary ? summary.textContent.trim() : this.capitalizeFirstLetter(filterType);

        filters.push({
          element: filter,
          label: label,
          values: this.extractFilterValues(filter),
          type: 'mobile',
          filterType: filterType
        });
      }
    });

    return filters;
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  extractFilterValues(filterElement) {
    const values = [];
    const checkboxes = filterElement.querySelectorAll('input[type="checkbox"]');

    checkboxes.forEach((checkbox) => {
      const label = checkbox.closest('label');
      if (label) {
        const textElement = label.querySelector('.facet-checkbox__text-label, .mobile-facets__label, .facet-checkbox__text');
        if (textElement) {
          const labelText = textElement.textContent.trim();

          const count = this.extractCount(labelText);

          const cleanLabel = labelText.replace(/\(\d+\)/, '').trim();

          const value = {
            value: checkbox.value,
            label: cleanLabel,
            active: checkbox.checked,
            disabled: checkbox.disabled,
            count: count
          };
          values.push(value);
        }
      }
    });

    return values;
  }

  extractCount(text) {
    const match = text.match(/\((\d+)\)/);
    return match ? parseInt(match[1]) : 0;
  }

  createFilterButtons(filter, buttonsContainer) {
    const filterContainer = document.createElement('div');
    filterContainer.className = 'filter-group';

    // Add "View all" button first
    const viewAllButton = this.createViewAllButton(filter);
    filterContainer.appendChild(viewAllButton);

    const validValues = filter.values
      .filter(filterValue => filterValue.count > 0)
      .sort((a, b) => this.sortFilterValues(a.label, b.label, filter.filterType));

    validValues.forEach(filterValue => {
      const button = this.createFilterButton(filterValue, filter);
      filterContainer.appendChild(button);
    });

    if (filterContainer.children.length > 0) {
      buttonsContainer.appendChild(filterContainer);
    }
  }

  sortFilterValues(a, b, filterType) {
    // If it's a size filter, use the existing size sorting logic
    if (filterType.toLowerCase() === 'size') {
      return this.sortSizes(a, b);
    }
    
    // For other filter types, use alphabetical sorting
    return a.localeCompare(b);
  }

  sortSizes(a, b) {
    const isLetterSize = (size) => /^[A-Z]+$/.test(size);

    const letterSizeOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];

    const aIsLetter = isLetterSize(a);
    const bIsLetter = isLetterSize(b);

    if (aIsLetter && !bIsLetter) return -1;
    if (!aIsLetter && bIsLetter) return 1;

    if (aIsLetter && bIsLetter) {
      const aIndex = letterSizeOrder.indexOf(a);
      const bIndex = letterSizeOrder.indexOf(b);
      return aIndex - bIndex;
    }

    if (!aIsLetter && !bIsLetter) {
      return parseInt(a) - parseInt(b);
    }

    return 0;
  }

  createViewAllButton(filter) {
    const button = document.createElement('button');
    button.type = 'button';
    const hasActiveFilter = filter.values.some(filterValue => filterValue.active);
    button.className = `view-all-button${hasActiveFilter ? '' : ' active'}`;
    button.textContent = 'View all';
    button.dataset.filterType = filter.filterType;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleViewAllClick(button, filter);
    });

    return button;
  }

  createFilterButton(filterValue, filter) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `filter-button ${filterValue.active ? 'active' : ''}`;
    button.textContent = filterValue.label;
    button.dataset.value = filterValue.value;
    button.dataset.filterType = filter.filterType;

    if (filterValue.disabled) {
      button.disabled = true;
      button.classList.add('disabled');
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleFilterClick(button, filterValue, filter);
    });

    return button;
  }

  handleViewAllClick(button, filter) {
    // Find all checkboxes for this filter type and uncheck them
    const desktopForm = document.querySelector('#FacetFiltersForm');
    const mobileForm = document.querySelector('#FacetFiltersFormMobile');
    
    const forms = [desktopForm, mobileForm].filter(form => form !== null);
    
    forms.forEach(form => {
      // Get all checkboxes in this form that belong to this filter type
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      
      checkboxes.forEach(checkbox => {
        // Check if this checkbox belongs to the current filter type
        const filterElement = checkbox.closest('.js-filter');
        if (filterElement && this.isFilterOfType(filterElement, filter.filterType)) {
          if (checkbox.checked) {
            checkbox.checked = false;
            // Trigger the form input event to update the page
            const event = new Event('input', { bubbles: true });
            checkbox.dispatchEvent(event);
          }
        }
      });
    });
    
    // Update button states after clearing
    setTimeout(() => {
      this.updateButtonStates();
    }, 100);
  }

  isFilterOfType(filterElement, filterType) {
    const filterId = filterElement.id;
    const filterTypeMap = {
      'size': ['size', 'filter.v.option.size'],
      'type': ['product_type', 'filter.p.product_type', 'type'],
      'category': ['filter.p.m.custom.category', 'custom.category'],
      'color': ['color', 'filter.v.option.color'],
      'vendor': ['vendor', 'filter.p.vendor'],
      'tag': ['tag', 'filter.p.tag']
    };

    const searchTerms = filterTypeMap[filterType.toLowerCase()] || [filterType.toLowerCase()];
    return searchTerms.some(term => 
      filterId && filterId.toLowerCase().includes(term.toLowerCase())
    );
  }

  handleFilterClick(button, filterValue, filter) {
    const checkbox = this.findCorrespondingCheckbox(filterValue.value, filter);

    if (checkbox) {
      checkbox.checked = !checkbox.checked;

      const form = checkbox.closest('form');
      if (form) {
        const event = new Event('input', { bubbles: true });
        checkbox.dispatchEvent(event);
      }

      button.classList.toggle('active', checkbox.checked);
      this.updateButtonStates();
    }
  }

  findCorrespondingCheckbox(value, filter) {
    const desktopForm = document.querySelector('#FacetFiltersForm');
    const mobileForm = document.querySelector('#FacetFiltersFormMobile');

    if (desktopForm) {
      const checkbox = desktopForm.querySelector(`input[type="checkbox"][value="${value}"]`);
      if (checkbox) return checkbox;
    }

    if (mobileForm) {
      const checkbox = mobileForm.querySelector(`input[type="checkbox"][value="${value}"]`);
      if (checkbox) return checkbox;
    }

    return null;
  }

  updateButtonStates() {
    this.filterContainers.forEach(container => {
      const buttons = container.querySelectorAll('.filter-button');
      let hasActiveFilter = false;

      buttons.forEach(button => {
        const value = button.dataset.value;
        const filterType = button.dataset.filterType;
        const checkbox = this.findCorrespondingCheckbox(value, { filterType: filterType });

        if (checkbox) {
          button.classList.toggle('active', checkbox.checked);
          button.disabled = checkbox.disabled;
          button.classList.toggle('disabled', checkbox.disabled);
          if (checkbox.checked) hasActiveFilter = true;
        }
      });

      container.querySelectorAll('.view-all-button').forEach(viewAllButton => {
        viewAllButton.classList.toggle('active', !hasActiveFilter);
      });
    });
  }

  reinitialize() {
    this.extractAndCreateFilters();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.dynamicFilters = new DynamicFilters();
});

document.addEventListener('facet:updated', () => {
  if (window.dynamicFilters) {
    window.dynamicFilters.updateButtonStates();
  }
});

document.addEventListener('facet:rendered', () => {
  if (window.dynamicFilters) {
    window.dynamicFilters.reinitialize();
  }
});

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (window.dynamicFilters) {
      console.log('Window resized, reinitializing dynamic filters...');
      window.dynamicFilters.reinitialize();
    }
  }, 250);
});
